import React from 'react'
import "./styles/Footer.css"
const Footer = () => {
  return (
    <footer>
      <p>Developed by Ivan S. Szelect</p>
    </footer>
  )
}

export default Footer
